export const AircraftExcelHeader = [
  {
    header: "CUSTOMER",
    key: "customer",
    width: 50,
  },
  {
    header: "A/C Registration",
    key: "acRegistration",
  },
  {
    header: "A/C Type Code",
    key: "aircraftTypeCode",
  },
  {
    header: "A/C MSN",
    key: "aircraftMsn",
  },
  {
    header: "Manufacturated Date",
    key: "manufacturatedDate",
  },
  {
    header: "Join to Fleet Date",
    key: "joinToFleetDate",
  },
  {
    header: "A/C Age",
    key: "aircraftAge",
  },
  {
    header: "Created Date",
    key: "createdDate",
  },
  {
    header: "Updated Date",
    key: "updatedDate",
  },
  {
    header: "Phase Out Date",
    key: "phaseOutDate",
  },
  {
    header: "Created By",
    key: "createdBy",
  },
  {
    header: "Updated By",
    key: "updatedBy",
  },
];

export const AircraftExcelName = "Aircraft List";
